import React, { ReactNode } from 'react';
import { SectionPanel } from '../view-content.js';

//-----------------------------------------------------------------------------------------
// Type Definitions:
//-----------------------------------------------------------------------------------------

type SectionContent = {
	title: string;
	description:ReactNode;
}

interface UserAgreementProps {
	id: string;
	title:string;
	sections: SectionContent[];
}


//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export default function UserAgreement(props: UserAgreementProps) {
	return (
		<div>
			<h2 id={`ga4-${props.id}`} className="view-content-section-header">{props.title}</h2>
			<div className="user-agreement-content">
				{props.sections.map((section: SectionContent, index: number) => (
					<SectionPanel
						key={`${section.title}-${index}`}
						border={true}
						shouldStartClosed={true}
						arrowColour="white"
						subHeading={`${index + 1}. ${section.title}`}
					>
						{section.description}
					</SectionPanel>
				))}	
			</div>
		</div>
	);
}
